import { Fragment, memo, useEffect, useState } from "react";
import useCallApiAndLoad from "../../../../hooks/useCallApiAndLoad";
import { logoutAction } from "../../../../redux/features/auth";
import { useDispatch, useSelector } from "react-redux";
import { AppStore } from "../../../../redux/store";
import { useNavigate, useParams } from "react-router-dom";
import { getAuthToken, unsetAuth } from "../../../../helpers/authHelper";
import {
  changeStatusKyc,
  getKycDetail,
  getKycForUnits,
  resendKYC,
} from "../../services/devsServices";
import { fetchResponseAdapter } from "../../../../adapters/fetchAdapter";
import MainTemplate from "../../layout/MainLayout";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
} from "@mui/material";
import {
  IconBrandWhatsapp,
  IconCheck,
  IconCircleArrowLeft,
  IconDownload,
  IconEye,
  IconLink,
  IconMail,
  IconSend,
  IconX,
} from "@tabler/icons-react";

import BtnPDF from "./_components/BtnPDF"

interface GuestList {
  coincidence: number;
  first_name: string;
  last_name: string;
  list_name: string;
}
interface Guest {
  name: string;
  email: string;
  phone: string;
  lists: GuestList[];
}

interface KycData {
  id: string;
  updated_at: string;
  guest_id: string;
  guest: Guest;
  project_name: string;
  unit_name: string;
  status:
  | "in_progress"
  | "need_customer_review"
  | "created"
  | "completed"
  | "rejected";
  comments: string;
  has_errors: boolean;
  can_approve: boolean;
  document_file: string;
}

const ITEMS_PER_PAGE = 5;

const styleOptions = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 600,
  bgcolor: "background.paper",
  borderRadius: "20px",
  p: 4,
  "@media(max-width: 768px)": {
    p: 2,
  },
};

const KCYModuleProjects = memo(() => {
  const { country } = useSelector((store: AppStore) => store.country);
  const [kycData, setKycData] = useState<KycData[]>([]);
  const [openListsModal, setOpenListsModal] = useState(false);
  const [currentLists, setCurrentLists] = useState<GuestList[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { id_unit = "" } = useParams();
  const user = useSelector((store: AppStore) => store.auth);
  const token = getAuthToken(user);
  const filters = useSelector((store: AppStore) => store.filtersProjects);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);
  const [selectedKycId, setSelectedKycId] = useState<string | null>(null);
  const [selectedKycData, setSelectedKycData] = useState<KycData | null>(null);
  const [detailKyc, setDetailKyc] = useState<any>(null);

  const { callEndpoint } = useCallApiAndLoad();

  useEffect(() => {
    const loadDataListKyc = async () => {
      setIsLoading(true);
      const { status, data } = await callEndpoint(
        getKycForUnits(token, id_unit)
      );
      if (status === 401) {
        dispatch(logoutAction({}));
        unsetAuth();
        navigate(`/app/${country}/auth/desarrolladoras/login`);
      }

      if (status === 200) {
        setIsLoading(false);
        const response = fetchResponseAdapter(data);
        setKycData(response.data.items || []);
      }
    };
    loadDataListKyc().catch((e) => console.error(e));
  }, []);

  useEffect(() => {
    const loadDataKyc = async () => {
      setIsLoading(true);
      const { status, data } = await callEndpoint(
        getKycDetail(token, id_unit, selectedKycId as string)
      );
      if (status === 401) {
        dispatch(logoutAction({}));
        unsetAuth();
        navigate(`/app/${country}/auth/desarrolladoras/login`);
      }

      if (status === 200) {
        setIsLoading(false);
        const response = fetchResponseAdapter(data);
        console.log("detalle", response?.data);
        // setKycData(response.data.items || []);
        setDetailKyc(response?.data?.steps);
      }
    };
    if (selectedKycId) {
      loadDataKyc().catch((e) => console.error(e));
    }
  }, [selectedKycId]);

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(kycData.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const currentData = kycData.slice(startIndex, endIndex);
  const [comment, setComment] = useState("");

  const [openCompleteDialog, setOpenCompleteDialog] = useState(false);
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [kycIdToAction, setKycIdToAction] = useState<string | null>(null);
  const [openModalOptions, setOpenOptions] = useState(false);

  const [loadingCompleted, setLoadingCompleted] = useState<boolean>(false);
  const [loadingRejected, setLoadingRejected] = useState<boolean>(false);

  const handleComplete = async () => {
    setLoadingCompleted(true);
    if (!kycIdToAction) return;

    const dataStatus = {
      status: "completed",
      comment: comment.trim() || "KYC ha sido revisado y aprobado.", // Usa el comentario o un mensaje por defecto
    };

    try {
      const { status, data } = await callEndpoint(
        changeStatusKyc(kycIdToAction, token, dataStatus)
      );

      if (status === 200) {
        const response = fetchResponseAdapter(data);
        setTimeout(() => {
          setComment(""); // Limpiar el comentario
          setOpenCompleteDialog(false);
          window.location.reload();
        }, 900);
        setLoadingCompleted(false);
      }
    } catch (error) {
      console.error(error);
      setLoadingCompleted(false);
    }
  };

  const handleReject = async () => {
    setLoadingRejected(true);
    if (!kycIdToAction || !comment.trim()) {
      // Validación adicional por si acaso (aunque el botón ya está deshabilitado)
      return;
    }

    const dataStatus = {
      status: "need_customer_review",
      comment: comment.trim(), // El comentario es requerido aquí
    };

    try {
      const { status, data } = await callEndpoint(
        changeStatusKyc(kycIdToAction, token, dataStatus)
      );

      if (status === 200) {
        const response = fetchResponseAdapter(data);
        setLoadingRejected(false);
        setTimeout(() => {
          setComment(""); // Limpiar el comentario
          setOpenRejectDialog(false);
          window.location.reload();
        }, 900);
      }
    } catch (error) {
      console.error(error);
      setLoadingRejected(false);
    }
  };

  const getStatusBadge = (status: string, hasErrors: boolean) => {
    switch (status) {
      case "completed":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg- text-primary">
            <svg
              className="w-3 h-3 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            Completado
          </span>
        );
      case "rejected":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
            <svg
              className="w-3 h-3 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            Rechazado
          </span>
        );
      case "in_progress":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            <svg
              className="w-3 h-3 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            En progreso
          </span>
        );
      case "need_customer_review":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
            <svg
              className="w-3 h-3 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Necesita revisión
          </span>
        );
      case "created":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            <svg
              className="w-3 h-3 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Creado
          </span>
        );
      case "partially_completed":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#fff3cd] text-[#856404]">
            <svg
              className="w-3 h-3 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Parcialmente completado
          </span>
        );
      case "in_review":
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            <IconCheck width={15} height={15} />
            En revisión
          </span>
        );
      default:
        return (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            Desconocido
          </span>
        );
    }
  };

  const handleOpenModal = (id: string) => {
    setSelectedKycId(id);
    const kycItem = kycData.find((item) => item.id === id);
    if (kycItem) {
      setSelectedKycData(kycItem);
    }
    setOpenModal(true);
  };

  // Función para cerrar el modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedKycId(null);
    setSelectedKycData(null);
  };

  const handleOpenListsModal = (lists: GuestList[]) => {
    setCurrentLists(lists);
    setOpenListsModal(true);
  };

  const backPage = () => {
    navigate(-1);
  };

  const handleResendKyc = async (providerSend: string) => {
    const dataSend = {
      id: selectedKycId,
      provider: providerSend,
    };

    try {
      const { status, data } = await callEndpoint(
        resendKYC(selectedKycId as string, token, dataSend)
      );

      if (status === 201) {
        const response = fetchResponseAdapter(data);
        setTimeout(() => {
          // setComment(""); // Limpiar el comentario
          // setOpenCompleteDialog(false);
          window.location.reload();
          setOpenOptions(false);
        }, 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseOptions = () => {
    setOpenOptions(false);
    setSelectedKycId(null);
  };

  const handleOpenResend = (id: string) => {
    setSelectedKycId(id);

    setOpenOptions(true);
  };

  const handleCopiar = (idKyc: string) => {
    const baseUrl = process.env.REACT_APP_BASE_URL || 'https://www.propilatam.com/';
    const url = `${baseUrl}${country}/cumplimiento/formulario/${idKyc}`;
    navigator.clipboard
      .writeText(url)
      .then(() => alert("URL copiada al portapapeles"))
      .catch(() => alert("Error al copiar"));
  };

  return (
    <MainTemplate>
      <div className="w-full py-28">
        <div className="container mx-auto px-4 lg:px-0">
          <h1 className="text-2xl font-semibold text-[#212121] inline-block">
            <button
              onClick={backPage}
              className=" outline-none focus:outline-none inline-block mr-2"
            >
              <IconCircleArrowLeft width={30} height={30} />
            </button>
            Revisión de KYC
          </h1>
          <p className="text-sm font-light">
            Verificamos y validamos la información de clientes interesados en
            proyectos inmobiliarios en preventa. Nuestro sistema de revisión KYC
            (Know Your Customer) garantiza que cada formulario cumpla con los
            requisitos legales y comerciales, asegurando procesos seguros,
            ágiles y confiables para desarrolladores y compradores.
          </p>
          <div className="w-full mx-auto space-y-6">
            {/* Header Card */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 mt-10">
              {/* Table Container */}
              <div className="px-4 py-4">
                {isLoading ? (
                  <div className="flex justify-center items-center py-10">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                  </div>
                ) : (
                  <>
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              <div className="flex items-center space-x-2">
                                <svg
                                  className="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                  />
                                </svg>
                                <span>Cliente</span>
                              </div>
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              <div className="flex items-center space-x-2">
                                <svg
                                  className="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                  />
                                </svg>
                                <span>Proyecto</span>
                              </div>
                            </th>

                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              <span>Estado</span>
                            </th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                              <span>Listas</span>
                            </th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                              <span>Acciones</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {currentData.map((item) => (
                            <tr
                              key={item.id}
                              className="hover:bg-gray-50 transition-colors duration-200"
                            >
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="space-y-1">
                                  <div className="text-sm font-medium text-gray-900">
                                    {item.guest.name}
                                  </div>
                                  <div className="flex items-center space-x-1 text-sm text-gray-500">
                                    <svg
                                      className="w-3 h-3"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                      />
                                    </svg>
                                    <span>{item.guest.email}</span>
                                  </div>
                                  <div className="flex items-center space-x-1 text-sm text-gray-500">
                                    <svg
                                      className="w-3 h-3"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                      />
                                    </svg>
                                    <span>{item.guest.phone}</span>
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm font-medium text-[#212121]">
                                  <p>{item.project_name}</p>
                                  <p className=" text-[#616161]">
                                    # {item.unit_name}
                                  </p>
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="space-y-1">
                                  {getStatusBadge(item.status, item.has_errors)}
                                  {item.comments && (
                                    <div
                                      className="text-xs text-gray-500 max-w-32 truncate"
                                      title={item.comments}
                                    >
                                      {item.comments}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-center">
                                {item?.guest?.lists &&
                                  item.guest.lists.length > 0 ? (
                                  <div className="flex flex-col items-center">
                                    <div>
                                      <div className="flex gap-1 justify-center flex-wrap">
                                        {item.guest.lists.map(
                                          (listItem, index) => (
                                            <span
                                              key={index}
                                              className="px-2 text-xs bg-[#cce5ff] text-[#004085] font-semibold rounded"
                                            >
                                              {listItem?.list_name}
                                            </span>
                                          )
                                        )}
                                      </div>

                                      {/* 
                                      --desactivado por redundancia, pero conservado por si se necesita en el futuro--
                                      <button
                                        onClick={() =>
                                          handleOpenListsModal(item.guest.lists)
                                        }
                                        className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md focus:outline-none mt-2 text-orange underline"
                                      >
                                        Ver listas vinculadas
                                      </button> */}
                                    </div>
                                    <BtnPDF className="text-orange" selectedKycId={item.id} />
                                  </div>
                                ) : (
                                  <div className="text-xs text-primary flex flex-col justify-center items-center">
                                    <div className="flex items-center gap-1">
                                      <IconCheck width={16} height={16} />{" "}
                                      Verificado
                                    </div>
                                    <BtnPDF className="text-primary" selectedKycId={item.id} />
                                  </div>
                                )}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-center">
                                <div className="flex items-center justify-center gap-2">
                                  <button
                                    onClick={() => handleCopiar(item.id)}
                                    className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-[#212121] hover:bg-grayForm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200 bg-grayForm gap-1"
                                  >
                                    <IconLink
                                      height={15}
                                      width={15}
                                      fontSize="small"
                                    />{" "}
                                    Copiar
                                  </button>
                                  {["partially_completed"].includes(
                                    item?.status
                                  ) && (
                                      <Fragment>
                                        <Fragment>
                                          <button
                                            onClick={() =>
                                              handleOpenModal(item.id)
                                            }
                                            className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200 bg-[#2962FF]"
                                          >
                                            <IconEye
                                              height={15}
                                              width={15}
                                              fontSize="small"
                                            />{" "}
                                            Ver
                                          </button>
                                        </Fragment>
                                      </Fragment>
                                    )}
                                  {["created", "in_progress"].includes(
                                    item.status
                                  ) && (
                                      <Fragment>
                                        <button
                                          onClick={() =>
                                            handleOpenResend(item.id)
                                          }
                                          className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200 bg-[#212121] gap-1"
                                        >
                                          <IconSend
                                            height={15}
                                            width={15}
                                            fontSize="small"
                                          />{" "}
                                          Reenviar
                                        </button>
                                      </Fragment>
                                    )}
                                  {["in_review", "in_progress"].includes(
                                    item.status
                                  ) && (
                                      <Fragment>
                                        <button
                                          onClick={() => handleOpenModal(item.id)}
                                          className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200 bg-[#2962FF]"
                                        >
                                          <IconEye
                                            height={15}
                                            width={15}
                                            fontSize="small"
                                          />{" "}
                                          Ver
                                        </button>
                                      </Fragment>
                                    )}
                                  {["in_review"].includes(item.status) && (
                                    <>
                                      {item?.can_approve && (
                                        <button
                                          onClick={() => {
                                            setKycIdToAction(item.id);
                                            setOpenCompleteDialog(true);
                                          }}
                                          className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-white bg-primary hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200"
                                        >
                                          <IconCheck className="w-4 h-4 mr-1" />
                                          Completar
                                        </button>
                                      )}

                                      <button
                                        onClick={() => {
                                          setKycIdToAction(item.id);
                                          setOpenRejectDialog(true);
                                        }}
                                        className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-white bg-red hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
                                      >
                                        <IconX className="w-4 h-4 mr-1" />
                                        Revisión
                                      </button>
                                    </>
                                  )}
                                  {item.status === "completed" && (
                                    <Fragment>
                                      {item?.document_file !== null && (
                                        <a
                                          href={item?.document_file}
                                          download={`${item?.guest?.name}-kyc.pdf`}
                                          className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-white bg-primary hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
                                        >
                                          <IconDownload className="w-4 h-4 mr-1" />
                                          Descargar KYC
                                        </a>
                                      )}
                                    </Fragment>
                                  )}
                                  {item.status === "rejected" && (
                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red text-white">
                                      <svg
                                        className="w-3 h-3 mr-1"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M6 18L18 6M6 6l12 12"
                                        />
                                      </svg>
                                      Rechazado
                                    </span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Paginación */}
                    <div className="flex flex-col lg:flex-row items-center justify-between mt-6 gap-2 lg:gap-0">
                      <div className="text-sm text-gray-600">
                        Mostrando {startIndex + 1} a{" "}
                        {Math.min(endIndex, kycData.length)} de {kycData.length}{" "}
                        registros
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1}
                          className="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                        >
                          <svg
                            className="w-4 h-4 mr-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 19l-7-7 7-7"
                            />
                          </svg>
                          Anterior
                        </button>

                        <div className="flex items-center space-x-1">
                          {Array.from(
                            { length: totalPages },
                            (_, i) => i + 1
                          ).map((page) => (
                            <button
                              key={page}
                              onClick={() => setCurrentPage(page)}
                              className={`inline-flex items-center justify-center w-8 h-8 text-sm font-medium rounded-md transition-colors duration-200 ${currentPage === page
                                ? "bg-[#212121] text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                : "text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                }`}
                            >
                              {page}
                            </button>
                          ))}
                        </div>

                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          disabled={currentPage === totalPages}
                          className="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                        >
                          Siguiente
                          <svg
                            className="w-4 h-4 ml-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Detalles del KYC - {selectedKycData?.guest.name}
        </DialogTitle>
        <DialogContent dividers>
          {detailKyc && (
            <div className="w-full">
              {detailKyc?.map((item: any, index: number) => (
                <div key={index} className="w-full mb-6">
                  <h2 className="text-lg font-semibold text-[#212121] mb-4">
                    {item?.title}
                  </h2>
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {" "}
                    {item?.questions?.map((question: any, qIndex: number) => (
                      <div key={qIndex} className="w-full">
                        {/* Caso especial para grupos */}
                        {question?.type === "group" && question?.value ? (
                          <div className="col-span-1">
                            <label className="font-normal text-sm text-[#757575] block mb-1">
                              {question?.label}
                            </label>
                            {question.value.map(
                              (groupItem: any, groupIndex: number) => (
                                <div
                                  key={groupIndex}
                                  className="mb-6 p-4 border rounded-lg"
                                >
                                  <h3 className="font-semibold text-base text-[#212121] mb-3">
                                    Ingreso adicional #{groupIndex + 1}
                                  </h3>
                                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                    {" "}
                                    {/* Asegurando una sola columna */}
                                    {question.questions?.map(
                                      (subQuestion: any, subQIndex: number) => {
                                        // Obtener el valor real del grupo actual
                                        const actualValue =
                                          groupItem[subQuestion.name];
                                        const options =
                                          subQuestion.options || [];

                                        return (
                                          <div
                                            key={subQIndex}
                                            className="w-full"
                                          >
                                            <label className="font-normal text-sm text-[#757575] block mb-1">
                                              {subQuestion.label}
                                            </label>

                                            {actualValue === "" ||
                                              actualValue === null ||
                                              actualValue === undefined ? (
                                              <p className="font-semibold text-base text-[#212121] italic">
                                                No proporcionado
                                              </p>
                                            ) : subQuestion.type ===
                                              "select" ? (
                                              <p className="font-semibold text-sm text-[#212121]">
                                                {options.find(
                                                  (opt: any) =>
                                                    opt.value === actualValue
                                                )?.label || actualValue}
                                              </p>
                                            ) : (
                                              <p className="font-semibold text-sm text-[#212121]">
                                                {actualValue}
                                              </p>
                                            )}
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        ) : (
                          /* Caso normal (no grupo) */
                          <>
                            {question?.type !== "checkbox" && (
                              <label className="font-normal text-sm text-[#757575] block mb-1">
                                {question?.label}
                              </label>
                            )}

                            {question?.value === "" ||
                              question?.value === null ||
                              question?.value === undefined ? (
                              <p className="font-semibold text-sm text-[#212121]">
                                No proporcionado
                              </p>
                            ) : question?.type === "checkbox" ? (
                              <p className="font-semibold text-base text-[#212121]">
                                {question.value
                                  ? "Aceptado ✔"
                                  : "Aún falta respuesta"}
                              </p>
                            ) : question?.type === "image" ? (
                              <div className="flex flex-col gap-2">
                                {question.value?.map(
                                  (fileUrl: string, index: number) => {
                                    const isImage =
                                      /\.(jpg|jpeg|png|gif|heic|heif)$/i.test(
                                        fileUrl
                                      );
                                    const fileName = fileUrl.split("/").pop(); // nombre del archivo

                                    return (
                                      <div
                                        key={index}
                                        className="flex items-center gap-2"
                                      >
                                        <div
                                          className={` ${isImage ? "w-20" : "w-auto"
                                            } h-20 bg-gray-200 rounded-md overflow-hidden flex items-center justify-center`}
                                        >
                                          {isImage ? (
                                            <img
                                              src={fileUrl}
                                              alt={question.label}
                                              className="object-cover object-left w-full h-full"
                                            />
                                          ) : (
                                            <span className="text-xs text-gray-700 text-center px-2 break-all">
                                              {fileName}
                                            </span>
                                          )}
                                        </div>

                                        <button
                                          onClick={() =>
                                            window.open(fileUrl, "_blank")
                                          }
                                          className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded hover:bg-blue-200 transition"
                                        >
                                          {isImage
                                            ? "Ver imagen"
                                            : "Ver documento"}
                                        </button>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : question?.type === "select" ? (
                              <p className="font-semibold text-sm text-[#212121]">
                                {question.options?.find(
                                  (opt: any) => opt.value === question.value
                                )?.label || question.value}
                              </p>
                            ) : (
                              <p className="font-semibold text-sm text-[#212121]">
                                {question.value}
                              </p>
                            )}
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <button
            className=" px-2 py-1 text-[#212121] font-medium"
            onClick={handleCloseModal}
            color="primary"
          >
            Cerrar
          </button>
        </DialogActions>
      </Dialog>
      {/* Diálogo de Completar */}
      <Dialog
        open={openCompleteDialog}
        onClose={() => {
          setComment("");
          setOpenCompleteDialog(false);
        }}
        maxWidth="sm"
        fullWidth
      >
        <div className="w-full">
          <DialogTitle>Confirmar Completar KYC</DialogTitle>
          <DialogContent>
            <label
              htmlFor="completeMessage"
              className="block mb-2 text-base font-medium text-[#212121]"
            >
              Estás seguro que deseas marcar este KYC como completado? Escribe
              un comentario (opcional)
            </label>
            <textarea
              id="completeMessage"
              rows={4}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              className="resize-none block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Comentarios adicionales..."
            />
          </DialogContent>
          <DialogActions>
            <button
              onClick={() => {
                setComment("");
                setOpenCompleteDialog(false);
              }}
              className="px-3 py-2 rounded-lg font-medium text-[#616161] bg-[#f5f5f5] text-center"
            >
              Cancelar
            </button>
            <button
              onClick={handleComplete}
              className="px-3 py-2 rounded-lg font-medium text-white bg-primary text-center text-sm flex justify-center items-center gap-2"
              disabled={!comment.trim() || loadingCompleted}
            >
              {loadingCompleted ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Procesando...
                </>
              ) : (
                "Confirmar"
              )}
            </button>
          </DialogActions>
        </div>
      </Dialog>

      {/* Diálogo de Rechazar */}
      <Dialog
        open={openRejectDialog}
        onClose={() => setOpenRejectDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <div className="w-full">
          <DialogTitle>Confirmar revisión de KYC</DialogTitle>
          <DialogContent>
            <label
              htmlFor="rejectMessage"
              className="block mb-2 text-base font-medium text-[#212121]"
            >
              ¿Estás seguro que deseas enviar a revisión este KYC? Escribe un
              comentario (requerido)
            </label>
            <textarea
              id="rejectMessage"
              rows={4}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              className="resize-none block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Razones por las cuales el cliente tiene que revisar sus datos..."
              required
            />
          </DialogContent>
          <DialogActions>
            <button
              onClick={() => setOpenRejectDialog(false)}
              className="px-3 py-2 rounded-lg font-medium text-[#616161] bg-[#f5f5f5] text-center"
            >
              Cancelar
            </button>
            <button
              onClick={handleReject}
              disabled={!comment.trim() || loadingRejected}
              className={`px-3 py-2 rounded-lg font-medium text-white bg-primary text-center text-sm flex justify-center items-center gap-1 ${!comment.trim() ? "opacity-50 cursor-not-allowed" : ""
                }`}
            >
              {loadingRejected ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Procesando...
                </>
              ) : (
                "Confirmar revisión"
              )}
            </button>
          </DialogActions>
        </div>
      </Dialog>
      {/* Modal para Listas Vinculadas */}
      <Dialog
        open={openListsModal}
        onClose={() => setOpenListsModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Resultados de Coincidencias</DialogTitle>
        <DialogContent dividers>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                    Nombre de Lista
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                    Nombre del Cliente
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                    Coincidencia (%)
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {currentLists.map((list, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">
                        {list.list_name}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900 capitalize">
                        {list.first_name} {list.last_name}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mr-2">
                          <div
                            className={`h-2.5 rounded-full ${list.coincidence > 90
                              ? "bg-primary"
                              : "bg-yellow-500"
                              }`}
                            style={{ width: `${list.coincidence}%` }}
                          ></div>
                        </div>
                        <span className="text-sm font-medium text-gray-700">
                          {list.coincidence}%
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            onClick={() => setOpenListsModal(false)}
            className="px-3 py-2 rounded-lg font-medium text-[#616161] bg-[#f5f5f5] text-center"
          >
            Cerrar
          </button>
        </DialogActions>
      </Dialog>

      <Modal
        open={openModalOptions}
        onClose={handleCloseOptions}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          m: 2,
        }}
      >
        <>
          <Box sx={styleOptions}>
            <h2 className=" text-xl font-semibold text-[#212121]">
              Reenviar KYC
            </h2>
            <p className="text-sm font-normal text-[#757575]">
              ¿Deseas reenviar el formulario de KYC al correo del cliente para
              que lo complete nuevamente? Elige por donde quieres enviarlo:
            </p>
            <div className="w-full flex justify-between items-center mt-4 flex-col-reverse lg:flex-row gap-2">
              <button
                onClick={handleCloseOptions}
                className=" bg-white border w-full lg:w-auto rounded-lg py-1.5 border-[#212121] text-center text-sm font-medium px-4"
              >
                Cancelar
              </button>
              <div className="w-full lg:w-auto grid grid-cols-2 gap-2">
                <button
                  onClick={() => handleResendKyc("email")}
                  className="bg-primary rounded-lg flex justify-center items-center gap-1 py-1.5 w-full lg:w-auto text-center text-sm font-medium text-white px-4"
                >
                  <IconMail /> Correo
                </button>
                <button
                  onClick={() => handleResendKyc("whatsapp")}
                  className="bg-primary rounded-lg flex justify-center items-center gap-1 py-1.5 w-full lg:w-auto text-center text-sm font-medium text-white px-4"
                >
                  <IconBrandWhatsapp /> WhatsApp
                </button>
              </div>
            </div>
          </Box>
        </>
      </Modal>
    </MainTemplate>
  );
});

KCYModuleProjects.displayName = "KCYModuleProjects";
export default KCYModuleProjects;


/* 
  Modificado por Daniel Bonilla Septiembre 2025
    - Se añadió llamada al botón PDF de compliance report
    - Se desabilitó el botón "Ver listas vinculadas" por redundancia con el nuevo componente PDF
*/